import { FieldType } from '@discngine/moosa-models';
import { selectTableColumnTypes } from '@discngine/moosa-store/tableConfig';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

export const useIdColumnKey = () => {
  const columnTypes = useSelector(selectTableColumnTypes);

  return useMemo(() => {
    const columnKeys = Object.keys(columnTypes);

    return columnKeys.find((key) => columnTypes[key] === FieldType.ID) ?? '';
  }, [columnTypes]);
};
